import { useGetList } from "ra-core";
import { Link } from "react-router";
import { Mail } from "lucide-react";

import { Card, CardContent } from "@/components/ui/card";

// Sprint 9.2 — InstantlyBanner : emails non lus à traiter.
// Source actuelle : unread_emails_summary (vue Supabase agrégée par compte).
// Quand l'intégration Instantly sera connectée, swap la source pour ses replies.

type UnreadRow = {
  id: string | number;
  account_email?: string;
  unread_count?: number;
};

export const InstantlyBanner = () => {
  const { data } = useGetList<UnreadRow>("unread_emails_summary", {
    pagination: { page: 1, perPage: 20 },
    sort: { field: "unread_count", order: "DESC" },
    filter: {},
  });

  const total = (data ?? []).reduce(
    (sum, row) => sum + (row.unread_count ?? 0),
    0,
  );
  if (total === 0) return null;

  return (
    <Card className="border-fabrik-blue/40">
      <CardContent className="py-3 md:py-3.5">
        <div className="flex items-start gap-2.5">
          <div className="size-7 rounded-md bg-fabrik-blue-soft text-fabrik-blue flex items-center justify-center shrink-0">
            <Mail className="size-3.5" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-[13px] font-semibold text-foreground leading-tight">
              {total} email{total > 1 ? "s" : ""} à traiter
            </p>
            <Link
              to="/mail"
              className="text-[12px] text-fabrik-blue hover:underline mt-0.5 inline-block"
            >
              Ouvrir la boîte de réception →
            </Link>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
